import { useModule } from "src/system/useModule.tsx";
import { useClientConfig } from "src/client-config/useClientConfig.ts";

export const useModuleDeleteDisabled = (resource: string) => {
  const { disableDelete } = useModule(resource);
  const clientConfig = useClientConfig();
  return typeof disableDelete === "function"
    ? disableDelete({
        clientConfig,
      })
    : disableDelete;
};
